import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'

export enum StrategyBannerType {
  RECOMMENDATIONS_IN_FORM = 'RECOMMENDATIONS_IN_FORM',
  RECOMMENDATIONS_ON_TRACK = 'RECOMMENDATIONS_ON_TRACK',
  NEXT_STEPS_IN_FORM = 'NEXT_STEPS_IN_FORM',
  SIP_NEXT_STEPS_IN_FORM = 'SIP_NEXT_STEPS_IN_FORM'
}

const STRATEGY_IN_FORM_IMAGE_URL = '/know-why/strategy-in-form.svg'
const STRATEGY_ON_TRACK_IMAGE_URL = '/know-why/strategy-on-track.svg'

const strategyBannerConfig: {
  [X in `${StrategyBannerType}`]: {
    imgPath: string
    heading: string
    subheading?: string
  }
} = {
  [StrategyBannerType.RECOMMENDATIONS_IN_FORM]: {
    imgPath: STRATEGY_IN_FORM_IMAGE_URL,
    heading: 'Recommendations for this In-form fund'
  },
  [StrategyBannerType.RECOMMENDATIONS_ON_TRACK]: {
    imgPath: STRATEGY_ON_TRACK_IMAGE_URL,
    heading: 'Recommendations for this On-track fund'
  },
  [StrategyBannerType.NEXT_STEPS_IN_FORM]: {
    imgPath: STRATEGY_IN_FORM_IMAGE_URL,
    heading: 'Next steps: Switch to In-form Funds',
    subheading: 'After exiting, invest in better-performing funds from the same category.'
  },
  [StrategyBannerType.SIP_NEXT_STEPS_IN_FORM]: {
    imgPath: STRATEGY_IN_FORM_IMAGE_URL,
    heading: 'Next steps for SIPs: Switch to In-form Funds',
    subheading: 'After exiting, invest in better-performing funds from the same category.'
  }
}

export const StrategyBanner = ({ bannerType }: { bannerType: `${StrategyBannerType}` }) => {
  const config = strategyBannerConfig[bannerType]
  const isNextSteps =
    bannerType === StrategyBannerType.NEXT_STEPS_IN_FORM || bannerType === StrategyBannerType.SIP_NEXT_STEPS_IN_FORM

  return (
    <div className='w-full z-0 flex gap-4 bg-white min-h-[90px] px-5 py-7 pb-8'>
      <div className='w-[40px] h-[40px]' aria-hidden='true'>
        <img
          className='w-auto h-full'
          src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}${config.imgPath}`}
          alt=''
          aria-hidden='true'
        />
      </div>
      <div className='flex-1'>
        {isNextSteps ? (
          <div className='text-[#232323] text-[16px] font-[400] leading-[140%]'>
            <h2 className='m-0 text-[16px] font-[400] leading-[140%]'>
              <span className='text-[#6A6E6E]'>
                {bannerType === StrategyBannerType.SIP_NEXT_STEPS_IN_FORM ? 'Next steps for SIPs: ' : 'Next steps: '}
              </span>
              <br />
              <span className='font-[500]'>Switch to In-form Funds</span>
            </h2>
            {config.subheading ? (
              <p className='m-0 mt-2 text-[#6A6E6E] font-[400] text-[14px] leading-[150%]'>{config.subheading}</p>
            ) : null}
          </div>
        ) : (
          <h2 className='m-0 text-[#232323] text-[16px] font-[400] leading-[140%]'>{config.heading}</h2>
        )}
      </div>
    </div>
  )
}
